<div
  mdbModal
  #loginModal="mdbModal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  [config]="{ ignoreBackdropClick: true }"
  (closed)="onClosed($event)"
>
  <div class="modal-dialog modal-dialog-centered" role="document" [ngClass]="{ 'modal-wide': isCheckout }">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close pull-right align-middle"
          aria-label="Close"
          (click)="loginModal.hide(); show = null; showChange.emit(show)"
        >
          <span aria-hidden="true">×</span>
        </button>
        <h3 class="modal-title w-100" data-testid="account-login-title">
          <i class="fas fa-user-circle"></i>
          Account login
        </h3>
      </div>
      <div class="modal-body">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-11">
              <div [ngClass]="this.isCheckout ? 'row vdivide' : ''">
                <div [ngClass]="this.isCheckout ? 'col-md-6 col-sm-6' : ''" style="padding-bottom: 20px">
                  <form class="form-box login-form form-validator" (ngSubmit)="onLoginSubmit()" #f="ngForm">
                    <h3 class="text-primary" style="font-weight: 400">Returning Customers</h3>

                    <p>If you have an account with us, please log in.</p>
                    <div class="alert alert-danger" role="alert" *ngIf="this.loginFailureMsg">
                      {{ this.loginFailureMsg }}
                    </div>
                    <div *ngIf="savedLoginInfo?.ProfusionShowDealsPending" class="note note-info mb-2">
                      To access your profusion deals, login to your account using this email <b>{{ savedLoginInfo.Email }}</b>.
                    </div>
                    <div *ngIf="savedLoginInfo?.ProfusionShowDealsPending" class="note note-info mb-2">
                      No Account?  We have pre-registered one for you, click <a class="text-primary" (click)="onForgetPassword(true)">here</a> to activate it.
                    </div>
                    
                    <div *ngIf="!savedLoginInfo?.ProfusionShowDealsPending && savedLoginInfo?.ShowConfirmAccount" class="note note-info mb-2">
                      You used <b>{{ savedLoginInfo.Email }}</b> to checkout as guest. You can
                      <a class="text-primary" (click)="onForgetPassword(true)">activate</a>
                      this account now to access your purchase history, saved addresses, etc.
                    </div>
                    <div class="form-group label-floating is-empty">
                      <label class="control-label">Enter Email<span class="required">*</span></label>

                      <input
                        type="email"
                        class="form-control {{ submitted && !password.valid ? 'ng-invalid ng-touched' : '' }}"
                        ngModel
                        name="email"
                        email
                        required
                        #email="ngModel"
                        data-testid="email-form-control-login"
                      />

                      <span class="material-input"></span>
                      <span
                        class="help-block invalidEntry"
                        *ngIf="(!email.valid && email.touched) || (submitted && !email.valid)"
                        >Please enter a valid email.</span
                      >
                    </div>
                    <div class="form-group label-floating is-empty">
                      <label class="control-label">Enter Password<span class="required">*</span></label>
                      <div class="input-group">
                        <input data-private
                          [type]="passowrdTextType ? 'text' : 'password'"
                          class="form-control  {{ submitted && !password.valid ? 'ng-invalid ng-touched' : '' }} "
                          ngModel
                          name="password"
                          required
                          #password="ngModel"
                          data-testid="password-form-control-login"
                        />
                        <div class="input-group-append">
                          <span class="input-group-text">
                            <i
                              class="fa"
                              [ngClass]="{
                                'fa-eye-slash': !passowrdTextType,
                                'fa-eye': passowrdTextType
                              }"
                              (click)="togglePasswordTextType()"
                            ></i>
                          </span>
                        </div>
                      </div>
                      <span class="material-input"></span>
                      <span
                        class="help-block invalidEntry"
                        *ngIf="(!password.valid && password.touched) || (submitted && !password.valid)"
                      >
                        Please enter a valid password.
                      </span>
                    </div>

                    <div class="buttons-box clearfix">
                      <button class="btn btn-primary btn-raised btn-block p-2" 
                        data-testid="login-btn"> 
                        <i class="fas fa-sign-in-alt"></i> Login</button
                      ><br />
                    </div>

                    <p class="forgot">Forgot Your Password?</p>
                    <p>
                      <a class="forgot text-primary" data-testid="create-a-new-password" (click)="onForgetPassword()">Create new Password?</a>
                      |
                      <a class="forgot text-primary" data-testid="use-a-magic-link" (click)="onMagicLinkActivated()">Or Use Magic link</a>
                     
                    </p>
                    <p>
                      <a class="text-primary" data-testid="create-account-btn" (click)="onCreateAccount($event)">Create an Account</a>
                    </p>
                  </form>
                  <!-- .form-box -->
                </div>

                <div class="col-md-6 col-sm-6" *ngIf="this.isCheckout">
                  <h3 class="text-primary" style="font-weight: 400; text-align: left">New Customer</h3>
                  <p>You will have the option to create your account after the checkout.</p>
                  <div class="content">
                    <div class="buttons-box clearfix">
                      <div type="button" class="btn btn-light btn-raised btn-md" data-testid="account-page-checkout-as-a-guest" (click)="onGuestCheckout()">
                        Check Out as a Guest
                      </div>
                    </div>

                    <p style="padding-top: 20px">&nbsp;</p>
                    <p style="font-weight: 400; text-align: left">We accept</p>
                    <i class="fab fa-cc-mastercard fa-2x padd-left"></i>
                    <i class="fab fa-cc-paypal fa-2x padd-left"></i>
                    <i class="fab fa-cc-visa fa-2x padd-left"></i>
                    <i class="fa-2x padd-left"><svg-icon class="cc-klarna" src="https://x.klarnacdn.net/payment-method/assets/badges/generic/black/klarna.svg"></svg-icon></i>
                  </div>
                </div>
              </div>
              <div align="center" style="padding-top: 30px"
                   *ngIf="isAnySocialLoginEnabled">
                <span style="text-align: center"></span>
                <button
                class="btn btn-raised btn-sm"
                (click)="onMagicLinkActivated()"> 
                  <i class="fab fa-sign-in-alt"></i> Magic Link - Sign with email
                </button>
                <button
                  class="btn btn-raised btn-sm"
                  (click)="signInWithTwitter()"
                  *ngIf="!config.Auth?.Twitter?.Disable"
                >
                  <i class="fab fa-twitter"></i> Twitter
                </button>
                <button
                  class="btn btn-raised btn-sm"
                  (click)="signInWithFacebook()"
                  *ngIf="!config.Auth?.Facebook?.Disable"
                >
                  <i class="fab fa-facebook-square"></i> Facebook
                </button>
                <button
                  class="btn btn-raised btn-sm"
                  (click)="signInWithGoogle()"
                  *ngIf="!config.Auth?.Google?.Disable"
                >
                  <i class="fab fa-google"></i> Google
                </button>
                <form [action]="externalLoginUrl" #twitterForm method="post" style="display: hidden">
                  <input type="hidden" [name]="apiService.xsrfFieldName" [value]="apiService.xsrfToken" />
                  <input type="hidden" name="returnUrl" [value]="returnURl" />
                  <input name="provider" value="Twitter" type="hidden" />
                </form>
              </div>
              <p style="padding-top: 40px; text-align: center">
                <span class="small">Copyright ©2021 Vistek Ltd. All Rights Reserved.</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  mdbModal
  #forgetPasswordModal="mdbModal"
  class="modal fade forget-password"
  tabindex="-10"
  role="dialog"
  aria-hidden="true"
  [config]="{
    ignoreBackdropClick: true,
    animated: true,
    backdrop: true
  }"
  (open)="onForgetPasswordOpened($event)"
  (closed)="onClosed($event)"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close pull-right align-middle"
          aria-label="Close"
          (click)="onCloseForgotPassword()"
        >
          <span aria-hidden="true">×</span>
        </button>
        <h3 class="modal-title w-100">
          <i class="fas fa-key"></i>
          {{ passwordReminderTitle }}
        </h3>
      </div>
      <div class="modal-body">
        <app-forget-password
          *ngIf="forgetPasswordModal.isShown"
          [emailAddress]="forgetPasswordEmail"
          [myModal]="forgetPasswordModal"
          [loginModal]="this.loginModal"
          [(responseReceived)]="forgetPasswordSent"
        ></app-forget-password>
      </div>
    </div>
  </div>
</div>


<div
  mdbModal
  #magicLinkModal="mdbModal"
  class="modal fade forget-password"
  tabindex="-10"
  role="dialog"
  aria-hidden="true"
  [config]="{
    ignoreBackdropClick: true,
    animated: true,
    backdrop: true
  }"
  (open)="onMagicLinkOpened($event)"
  (closed)="onClosed($event)"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close pull-right align-middle"
          aria-label="Close"
          (click)="onCloseMagicLink()"
        >
          <span aria-hidden="true">×</span>
        </button>
        <h3 class="modal-title w-100">
          <i class="fas fa-key"></i>
          {{ passwordReminderTitle }}
        </h3>
      </div>
      <div class="modal-body">
        <app-magic-link
          *ngIf="magicLinkModal.isShown"
          [emailAddress]="forgetPasswordEmail"
          [myModal]="magicLinkModal"
          [loginModal]="this.loginModal"
          [(responseReceived)]="magicLinkSent"
        ></app-magic-link>
      </div>
    </div>
  </div>
</div>

<div
  mdbModal
  #createAccountModal="mdbModal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  style="overflow-y: auto"
  [config]="{ ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="createAccountModal.hide(); show = null; showChange.emit(show)"
        >
          <span aria-hidden="true">×</span>
        </button>

        <h3 class="modal-title w-100 text-primary" data-testid="create-account-title">
          <i class="fas fa-user-circle"></i>
          Create Account
        </h3>
      </div>
      <div class="modal-body">
        <app-create-account
          *ngIf="createAccountModal.isShown"
          (accountCreated)="createAccountModal.hide()"
          (accountExistsAction)="onAccountExistsAction($event)"
        ></app-create-account>
      </div>
    </div>
  </div>
</div>
